module.exports = __webpack_public_path__ + "img/font_vivaldi.7866443.svg";